import * as React from 'react';

export const IconTrust16 = () => {
  return (
    // eslint-disable-next-line react/forbid-elements
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.073 2.037A29.072 29.072 0 0 1 7 0C5.833.7 4.667 1.3 3.5 1.8 2.333 2.3 1.167 2.7 0 3l.42 4.2a9 9 0 0 0 6.11 7.643L7 15l.47-.157A9 9 0 0 0 13.58 7.2L14 3a23.214 23.214 0 0 1-1.656-.493l.047.056-.16.193a35.272 35.272 0 0 0-5.158 8.364l-.262.603-.284-.594c-.604-1.264-1.82-3.006-2.744-3.98l-.186-.194 1.24-1.464.23.247A13.788 13.788 0 0 1 6.73 7.895c1.046-1.881 2.82-4.234 4.342-5.858z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};
